import React from 'react';
import { createContainer } from 'react-tracked';
export var MilestoneAgentName;
(function (MilestoneAgentName) {
    MilestoneAgentName["NONE"] = "NONE";
    MilestoneAgentName["SPOTTER_CHAT"] = "SPOTTER_CHAT";
    MilestoneAgentName["SPOTTER_VIZ"] = "SPOTTER_VIZ";
    MilestoneAgentName["SPOTTER_CODE"] = "SPOTTER_CODE";
})(MilestoneAgentName || (MilestoneAgentName = {}));
export var MilestoneStatus;
(function (MilestoneStatus) {
    MilestoneStatus["NONE"] = "NONE";
    MilestoneStatus["STARTED"] = "STARTED";
    MilestoneStatus["FINISHED"] = "FINISHED";
})(MilestoneStatus || (MilestoneStatus = {}));
export var SparkflowBlinkActionType;
(function (SparkflowBlinkActionType) {
    SparkflowBlinkActionType[SparkflowBlinkActionType["UPDATE_SPARKFLOW_GLOBAL_CONTEXT"] = 0] = "UPDATE_SPARKFLOW_GLOBAL_CONTEXT";
    SparkflowBlinkActionType[SparkflowBlinkActionType["REQUEST_CHECKLIST_REFRESH"] = 1] = "REQUEST_CHECKLIST_REFRESH";
    SparkflowBlinkActionType[SparkflowBlinkActionType["UPDATE_MILESTONE"] = 2] = "UPDATE_MILESTONE";
})(SparkflowBlinkActionType || (SparkflowBlinkActionType = {}));
export const defaultSparkflowContextOptions = {
    hideSparkflowBanner: false,
    spotterVizConfig: {
        prefilledSampleQuestions: undefined,
        starterPrompts: undefined,
    },
    spotbuildGenResponse: [],
    savedRole: undefined,
    isLoadingIndicatorVisible: false,
    checklistRefreshRequested: false,
    lastOpenedChecklistSectionId: undefined,
    spotterConversationResetKey: undefined,
    milestone: {
        isModalOpen: false,
        agentName: MilestoneAgentName.NONE,
        status: MilestoneStatus.NONE,
    },
    isGeneratedIdsLoading: true,
    sparkflowPinboardId: null,
};
const reducer = (state = defaultSparkflowContextOptions, action) => {
    switch (action.type) {
        case SparkflowBlinkActionType.UPDATE_SPARKFLOW_GLOBAL_CONTEXT:
            return { ...state, ...action.data };
        case SparkflowBlinkActionType.REQUEST_CHECKLIST_REFRESH:
            return { ...state, ...action.data };
        case SparkflowBlinkActionType.UPDATE_MILESTONE:
            return {
                ...state,
                milestone: {
                    ...state.milestone,
                    ...action.data,
                },
            };
        default:
            return state;
    }
};
const getDispatcherFunctions = (dispatch) => ({
    updateSparkflowGlobalContext: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.UPDATE_SPARKFLOW_GLOBAL_CONTEXT,
            data,
        });
    },
    requestChecklistRefresh: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.REQUEST_CHECKLIST_REFRESH,
            data,
        });
    },
    updateMilestone: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.UPDATE_MILESTONE,
            data,
        });
    },
});
function getOrCreateContainer() {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.sparkflowBlinkContainer) {
        return window.blink.sparkflowBlinkContainer;
    }
    const { Provider, useTrackedState, useUpdate } = createContainer(({ initialState }) => React.useReducer(reducer, initialState));
    const container = {
        Provider,
        useTrackedState,
        useDispatch: useUpdate,
    };
    window.blink = window.blink || {};
    window.blink.sparkflowBlinkContainer = container;
    return container;
}
const { Provider: InternalProvider, useTrackedState, useDispatch, } = getOrCreateContainer();
const SparkflowContextProvider = ({ children, value = {}, }) => (React.createElement(InternalProvider, { initialState: { ...defaultSparkflowContextOptions, ...value } }, children));
const getSparkflowGlobalContext = () => {
    try {
        return useTrackedState() || defaultSparkflowContextOptions;
    }
    catch (e) {
        if (/Please use <Provider>/.test(e === null || e === void 0 ? void 0 : e.message)) {
            return {};
        }
        throw e;
    }
};
const setSparkflowGlobalContext = () => {
    const dispatch = useDispatch();
    return dispatch
        ? getDispatcherFunctions(dispatch)
        : {};
};
export { SparkflowContextProvider, getSparkflowGlobalContext, setSparkflowGlobalContext, };
//# sourceMappingURL=sparkflow-context.js.map